export default __webpack_public_path__ + "static/w-paper-0938f98f8a72a0c952847271637fd545.svg";